import React from 'react';
import OverallCanvasGraph from './OverallGraph';
import MainGraph from './ChapterWiseGraph';

function CFA3CBTResult(props) {
  return (
    <div>
      <OverallCanvasGraph {...props} />
      <MainGraph {...props} />
    </div>
  );
}

export default CFA3CBTResult;



// WEBPACK FOOTER //
// ./src/views/CBT/CFA3CBT/ResultGraph/index.jsx